import { useEffect } from 'react';
import { isE2eMode, reauthenticateE2eSession } from '~/lib/e2eAuth';

export function SignInRedirect() {
  useEffect(() => {
    async function signIn() {
      if (isE2eMode) {
        window.location.assign(
          (await reauthenticateE2eSession()) ? '/' : '/signed-out'
        );
        return;
      }
      window.location.assign(`/oauth2/authorization/cognito`);
    }

    signIn();
  }, []);

  return <div>Redirecting...</div>;
}
